import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { FetchTasksTarget, MemberTasksRequestState, MemberTasksState, MemberTask } from './types'

const initialRequestState: MemberTasksRequestState = {
  isLoading: false,
  isRefreshing: false,
  error: null,
  lastFetchedAt: null,
}

const initialState: MemberTasksState = {
  episodeId: null,
  list: [],
  request: { ...initialRequestState },
}

const { actions, reducer } = createSlice({
  name: 'memberTasks',
  initialState,
  reducers: {
    // Trigger only: the saga decides whether to actually fetch (see fetchTasksStarted).
    fetchTasks: (_state, _action: PayloadAction<FetchTasksTarget & { force?: boolean }>) => {},

    fetchTasksStarted: (state, action: PayloadAction<{ episodeId: string }>) => {
      if (state.episodeId !== action.payload.episodeId) {
        state.episodeId = action.payload.episodeId
        state.list = []
        state.request.lastFetchedAt = null
      }
      const hasData = state.list.length > 0
      state.request.isLoading = !hasData
      state.request.isRefreshing = hasData
      state.request.error = null
    },

    fetchTasksSuccess: (
      state,
      action: PayloadAction<{ episodeId: string; tasks: MemberTask[]; fetchedAt: number }>
    ) => {
      state.episodeId = action.payload.episodeId
      state.list = action.payload.tasks
      state.request.isLoading = false
      state.request.isRefreshing = false
      state.request.error = null
      state.request.lastFetchedAt = action.payload.fetchedAt
    },

    fetchTasksFailure: (state, action: PayloadAction<{ episodeId: string; error: unknown }>) => {
      state.episodeId = action.payload.episodeId
      state.request.isLoading = false
      state.request.isRefreshing = false
      state.request.error = action.payload.error
    },

    reset: () => initialState,
  },
})

export { actions as memberTasks, initialState }

export default reducer
